module.exports = __webpack_public_path__ + "img/Group82.761e5aa6.svg";